import { Component } from '@angular/core';
import { AppRoutes } from '@bn/dashboard-core/enums';
import { AbstractLazyDirective } from '@bn/shared/entities/abstracts/abstract-lazy.directive';
import { LazyLoadDirective } from '@bn/web-ui';
import { NgStyle } from '@angular/common';
import { ButtonComponent } from '@bn/web-ui/button/button.component';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'bn-product-not-found',
  templateUrl: './product-not-found.page.html',
  styleUrls: ['product-not-found.page.scss'],
  imports: [LazyLoadDirective, NgStyle, ButtonComponent, RouterLink],
})
export class ProductNotFoundPage extends AbstractLazyDirective {
  public productName? = ['Pull Zone'];
  public productRoute?: AppRoutes = undefined;

  public routeNames: Partial<{ [key in AppRoutes]: string[] }> = {
    [AppRoutes.CDN]: ['Pull Zone'],
    [AppRoutes.DNS]: ['DNS zone'],
    [AppRoutes.Storage]: ['Storage zone'],
    [AppRoutes.Script]: ['Script'],
    [AppRoutes.MagicContainers]: ['Magic Container App'],
    [AppRoutes.Stream]: ['Video library', 'Video libraries'],
    [AppRoutes.Database]: ['Database', 'Database'],
  };

  constructor() {
    super();

    this.productRoute = this.route.snapshot.queryParams.product;

    if (this.productRoute) this.productName = this.routeNames[this.productRoute];
  }
}
